import { DrinkCategories } from "./conts";
import MenuList from "../../Components/MenuList";

const DrinksPage = () => {
  return <MenuList categories={DrinkCategories} />;
};

export default DrinksPage;
